import React, { useCallback } from "react";
import cx from "classnames";
import { Share } from "../Icons/Share";
import "./ShareButton.scss";
import { Action } from "./Action";

interface Props {
    className?: string;
}

export const ShareButton: React.FunctionComponent<Props> = ({ className }) => {
    const isSupported = Boolean(navigator.share);

    const handleShare = useCallback(() => {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                url: window.location.href,
            }).catch(console.error);
        }
    }, []);

    if (!isSupported) {
        return null;
    }

    return (
        <Action
            className={cx("share-button", className)}
            onClick={handleShare}
            aria-label="Share this page"
        >
            <Share />
        </Action>
    );
};
